import React from 'react';
export function FeaturedIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M7.707 4.293l-3-3-1.414 1.414 3 3 1.414-1.414z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.923 2.615a1 1 0 00-1.846 0L8.833 8H4a1 1 0 00-.692 1.722l3.874 3.712-2.108 5.19a1 1 0 001.373 1.27L12 17.118l5.553 2.776a1 1 0 001.373-1.27l-2.108-5.19 3.874-3.712A1 1 0 0020 8h-4.833l-2.244-5.385zm-2.5 6.77L12 5.6l1.577 3.785A1 1 0 0014.5 10h3.011l-2.566 2.46a1 1 0 00-.235 1.098l1.366 3.362-3.629-1.814a1 1 0 00-.894 0L7.924 16.92l1.366-3.362a1 1 0 00-.234-1.098L6.489 10H9.5a1 1 0 00.923-.615z"
  }), React.createElement("path", {
    d: "M0 13h4v2H0v-2zm24 0h-4v2h4v-2zm-11 7v4h-2v-4h2zm4.707-14.293l3-3-1.414-1.414-3 3 1.414 1.414z"
  }));
}